import {
  AcyclovirCreamConsultationUpsell,
  AcyclovirCreamHSVConsultationUpsell,
  AhWellnessPanelConsultationUpsell,
  AtopiclairBarrierCreamConsultationUpsell,
  AzelaicAcidConsultationUpsell,
  ClindamycinVaginalCreamConsultationUpsell,
  ClotrimazoleVaginalCreamConsultationUpsell,
  DeliverMedicationConsultationUpsell,
  DoctorsNoteConsultationUpsell,
  Doxycycline1TreatmentConsultationUpsell,
  Doxycycline15TreatmentsConsultationUpsell,
  Doxycycline30TreatmentsConsultationUpsell,
  Doxycycline30TreatmentsUpsellFrom15ConsultationUpsell,
  DoxycyclineConsultationUpsell,
  FiberSupplementConsultationUpsell,
  FluconazoleConsultationUpsell,
  FluconazoleForBVTreatmentConsultationUpsell,
  FollowUpStdTestConsultationUpsell,
  FollowUpUrineTestConsultationUpsell,
  Glp1BoosterConsultationUpsell,
  LevonorgestrelConsultationUpsell,
  LidocaineOintmentConsultationUpsell,
  MaleBVPartnerTreatmentConsultationUpsell,
  MensIntimateWashConsultationUpsell,
  MetforminExtendedReleaseStdConsultationUpsell,
  MetforminStdConsultationUpsell,
  MetronidazoleConsultationUpsell,
  MetronidazoleVaginalGelConsultationUpsell,
  MinoxidilConsultationUpsell,
  OndansetronDissolvableTabletStdConsultationUpsell,
  OndansetronPillStdConsultationUpsell,
  OralAntiInflammatorySkinMedicationConsultationUpsell,
  OvernightShippingConsultationUpsell,
  PartnerTreatmentConsultationUpsell,
  PriorityProcessingConsultationUpsell,
  ProbioticsConsultationUpsell,
  PyridiumConsultationUpsell,
  RectalCreamAndSuppositoryConsultationUpsell,
  SemaglutideInjectable0_5mgConsultationUpsell,
  SemaglutideInjectable1_7mgConsultationUpsell,
  SemaglutideInjectable1mgConsultationUpsell,
  SemaglutideInjectable2_5mgConsultationUpsell,
  SemaglutideOral5mgConsultationUpsell,
  SemaglutideOral12mgConsultationUpsell,
  ShippedProbioticsConsultationUpsell,
  Spf50SunscreenConsultationUpsell,
  Std10TestPanelConsultationUpsell,
  StoolSoftenerConsultationUpsell,
  TirzepatideInjectable5mgConsultationUpsell,
  TirzepatideInjectable7_5mgConsultationUpsell,
  TirzepatideInjectable10mgConsultationUpsell,
  TirzepatideInjectable12_5mgConsultationUpsell,
  TirzepatideInjectable15mgConsultationUpsell,
  TirzepatideOral4mgConsultationUpsell,
  TirzepatideOral5mgConsultationUpsell,
  VasculeraConsultationUpsell,
  VitaminB12SupplementConsultationUpsell,
  VitaminDSupplementConsultationUpsell,
  ZincSupplementConsultationUpsell,
  ZofranTreatmentDissolvableTabletConsultationUpsell,
} from '@data/consultation-request-upsells';
import { Pharmacy } from '@enums/pharmacies';
import { Sites } from '@enums/sites';
import { UpsellSlugs } from '@enums/upsell-slugs';
import { AppEnvironment } from '@models/app-environment';

/**
 * Environment variables for use on the Starfish site, both in production and local environment.
 */
export const starfishCommonEnvironment = {
  site: Sites.Starfish,
  domain: 'Starfish.com',
  siteId: '18',
  faviconFile: 'starfish-favicon.ico',
  phone: '1-866-760-3593',
  email: 'support@starfish.com',
  businessHours: 'Monday - Sunday 8 a.m. - 8 p.m. (Central Standard Time - CST)',
  allowedRoutes: [
    '/null',
    '/order',
    '/female-condom',
    '/ed-treatment',
    '/order-complete.php',
    '/consultation/vaginal-cream',
    '/consultation/acne/request',
    '/consultation/bacterial-vaginosis/request',
    '/consultation/hemorrhoids/request',
    '/consultation/uti/request',
    '/consultation/std/request',
    '/consultation/hsv/request',
    '/consultation/yeast-infection/request',
    '/consultation/std-prevention/request',
    '/consultation/metformin/request',
    '/consultation/glp-1/request',
    '/consultation/glp-1-renewal/request',
    '/consultation/male-bv/request',
    '/consultation/zofran/request',
    '/consultation/rash/request',
    '/consultation/yeast-infection-prevention',
    '/consultation/alleviate-nausea-and-vomiting',
    '/consultation/replenish-your-good-bacteria',
    '/consultation/be-prepared-for-the-unexpected',
    '/consultation/need-a-doctors-note',
    '/consultation/relieve-outbreak-pain',
    '/consultation/prevent-vitamin-b12-deficiency',
    '/consultation/maximize-your-glp-1-results',
    '/consultation/medication-pickup-or-delivery',
    '/consultation/upload-consult-attachments',
    '/consultation/schedule-consultation',
    '/consultation/clotrimazole-vaginal-cream',
    '/consultation/mens-intimate-wash',
    '/consultation/follow-up-std-test',
    '/consultation/payment-info',
    '/consultation/vitamin-d-supplement',
    '/consultation/wellness-panel',
    '/consultation/stool-softener',
    '/consultation/azelaic-acid',
    '/consultation/zinc-supplement',
    '/acne/consultation-request-completed',
    '/yeast-infection/consultation-request-completed',
    '/bacterial-vaginosis/consultation-request-completed',
    '/hemorrhoids/consultation-request-completed',
    '/uti/consultation-request-completed',
    '/std/consultation-request-completed',
    '/std-prevention/consultation-request-completed',
    '/hsv/consultation-request-completed',
    '/male-bv/consultation-request-completed',
    '/zofran/consultation-request-completed',
    '/metformin/consultation-request-completed',
    '/glp-1/consultation-request-completed',
    '/glp-1-renewal/consultation-request-completed',
    '/rash/consultation-request-completed',
    '/consultation/submission-error',
    '/consultation/fiber-supplement',
    '/consultation/expedited-shipping',
    '/consultation/metformin',
    '/consultation/spf50-sunscreen',
    '/consultation/priority-processing',
    '/consultation/hair-growth',
  ],
  enablePayLater: false,
  enableBitPay: false,
  enableGiftCard: true,
  enableBusinessAccounts: false,
  applePayLabel: 'Analyte Health',
  order: {
    minAgeAllowed: 18,
    showCancellationPolicy: false,
    navigateToOrderAddressRoute: false,
    shouldShowPhoneFieldOnOrderRoute: true,
    hasPhysicianFee: false,
    physicianFeeInCents: 0,
    forceEmailResults: true,
    isPartnerTestingAllowed: false,
    orderPaymentFormLayout: 'stacked',
    enableOrderUpgrade: false,
    enableDynamicOrderUpgrade: false,
    enableTosOnOrderPage: true,
    stdPanelWithMycoplasmaTestId: 3162,
    abTestsWithMycoplasmaTestId: [3377, 3379, 3376],
    comprehensiveWellnessPanelId: 3381,
    isFemaleCondomUpsellAllowed: true,
    triggerFemaleCondomUpsellConsultation: false,
    skipUpsellsForBusinessAccounts: false,
    orderSummary: {
      allowEditingCart: false,
      editCartButtonText: 'Edit',
      displayCartSummaryTableHeaders: false,
      testsPrefix: 'Medication Online',
      showCouponCode: false,
      displayFindTestsModal: false,
    },
    orderComplete: {
      displaySisterSiteBanner: false,
      testOrderedWording: {
        single: 'Preferred Medication/Treatment',
        plural: 'Preferred Medications/Treatments',
      },
    },
  },
  maxAgeAllowed: 81,
  minimumNameLength: 2,
  disableSchedulingRedirectForTreatmentTypes: [],
  consultation: {
    deliveryPharmacyId: Pharmacy.TAHA,
    lastPeriodQuestionId: '97',
    erectileDysfunctionMedicationQuestionId: '234',
    offersEdTreatmentUpsell: true,
    highBloodPressureQuestionId: '228',
    breastfeedingQuestionIds: ['31', '82'],
  },
  ngFindalab: {
    findalabMapId: '8f1673661122dda0',
    searchEndpoint: '/pharmacies/labs/nearPostalCode',
    filterByStates: null,
    inHomeCollectionAllowed: false,
    inHomeCollectionCostInCents: 11900,
    inHomeCollectionProviderIds: [1, 2],
    showPhone: true,
    filterByTestAndSite: false,
    getNetworksFromTests: false,
    verifyTestsCanBeOrdered: false,
    validateSelectedLabNetwork: false,
    searchTitle: 'Enter Your Location',
    searchDescription:
      'Please choose a nearby pharmacy where our clinician can send your prescription once they have reviewed your medical information and your order has been placed.',
    pharmacySearchDescription:
      'Please choose a nearby pharmacy where our clinician can send your prescription once they have reviewed your medical information.',
    locateMsg: 'Use my current location',
    labButtonText: 'Choose This Pharmacy',
    searchButtonText: 'Find',
    showSearchIcon: false,
    labIconClass: 'fa fa-arrow-right',
    searchMessageNoResults:
      'Oops! Sorry, we could not find any pharmacies near that location. Please try your search again with a different or less specific address.',
    inputGroup: {
      container: '',
      field: null,
      button: '',
    },
    resultsZoom: 12,
    choosePharmacySearchTitle: 'Enter Your Location',
    showDayOfWeekFilter: false,
  },
  titles: {
    order: 'Checkout - Starfish',
    consultationRequest: 'Questionnaire - Starfish',
    headlineCheckoutScheduled: '',
    step1Title: 'Find a Pharmacy',
    selectedCenterLabel: 'Pharmacy',
    orderPageHeader: {
      title: "You're almost <strong>Done!</strong>",
      subtitle: 'We just need a few more details before determining your diagnosis.',
    },
    scheduledConsultationRequest: {
      title: 'Clinician Phone Consultation Needed',
      calendarDetails:
        'To ensure compliance with Telehealth regulations in your state, we must arrange a brief phone consultation with one of our clinicians before prescribing medication. This consultation is provided at no additional cost to you.',
      phoneNumberDetails: 'A Clinician will call you at',
      availabilityDetails:
        "Typically, our clinicians call earlier than the anticipated window, so there's no need to be concerned if your appointment appears to be scheduled further than expected.",
    },
  },
  buttons: {
    checkout: 'Place Order',
    selectedCenterChange: 'Change Pharmacy',
  },
  styles: {
    metaThemeColor: '#fff4e9',
    chooseAPharmacy: {
      labButtonClass: 'is-secondary-orange has-text-white',
      searchButtonClass: 'is-green has-text-white',
      googleMapsLabMarkerFillColor: '#fa676b',
      googleMapsRecommendedMarkerFillColor: '#fdd8d9',
      googleMapsMarkerHoverFillColor: '#f84f55',
    },
    consultationRequest: {
      headlineClass: 'column is-flex is-justify-content-center pt-5 pb-0 has-text-weight-semibold',
    },
    healthLabsCoupon: {
      buttonColor: 'secondary-orange',
    },
    orderCompleteInstructions: {
      cardContentClass: '',
    },
    orderBetterLab: {
      orderPlaceNotificationClass: 'is-warning',
      currentTestCenterNotificationClass: 'is-info',
      keepCurrentLabButtonClass: 'is-uppercase',
      keepCurrentLabButtonColor: 'secondary-orange',
    },
    testCenter: {
      labButtonClass: '',
      searchButtonClass: 'is-secondary-orange has-text-white',
      googleMapsLabMarkerFillColor: '#fa676b',
      googleMapsRecommendedMarkerFillColor: '#fdd8d9',
      googleMapsMarkerHoverFillColor: '#f84f55',
    },
  },
  shopperApproved: {
    site: 40107,
    token: '330wDBfS',
  },
  consultationRequestUpsells: {
    [UpsellSlugs.Pyridium]: PyridiumConsultationUpsell,
    [UpsellSlugs.FollowUpUrineTest]: FollowUpUrineTestConsultationUpsell,
    [UpsellSlugs.Fluconazole]: FluconazoleConsultationUpsell,
    [UpsellSlugs.FluconazoleForBVTreatment]: FluconazoleForBVTreatmentConsultationUpsell,
    [UpsellSlugs.Metronidazole]: MetronidazoleConsultationUpsell,
    [UpsellSlugs.Probiotics]: ProbioticsConsultationUpsell,
    [UpsellSlugs.ShippedProbiotics]: ShippedProbioticsConsultationUpsell,
    [UpsellSlugs.DoctorsNote]: DoctorsNoteConsultationUpsell,
    [UpsellSlugs.Levonorgestrel]: LevonorgestrelConsultationUpsell,
    [UpsellSlugs.DeliverMedication]: DeliverMedicationConsultationUpsell,
    [UpsellSlugs.OndansetronPill]: OndansetronPillStdConsultationUpsell,
    [UpsellSlugs.OndansetronDissolvableTablet]: OndansetronDissolvableTabletStdConsultationUpsell,
    [UpsellSlugs.MetronidazoleVaginalGel]: MetronidazoleVaginalGelConsultationUpsell,
    [UpsellSlugs.ClindamycinVaginalCream]: ClindamycinVaginalCreamConsultationUpsell,
    [UpsellSlugs.ClotrimazoleVaginalCream]: ClotrimazoleVaginalCreamConsultationUpsell,
    [UpsellSlugs.MensIntimateWash]: MensIntimateWashConsultationUpsell,
    [UpsellSlugs.FollowUpStdTest]: FollowUpStdTestConsultationUpsell,
    [UpsellSlugs.PartnerTreatment]: PartnerTreatmentConsultationUpsell,
    [UpsellSlugs.LidocaineOintment]: LidocaineOintmentConsultationUpsell,
    [UpsellSlugs.VitaminB12Supplement]: VitaminB12SupplementConsultationUpsell,
    [UpsellSlugs.VitaminDSupplement]: VitaminDSupplementConsultationUpsell,
    [UpsellSlugs.MetforminExtendedRelease]: MetforminExtendedReleaseStdConsultationUpsell,
    [UpsellSlugs.AcyclovirCreamHSV]: AcyclovirCreamHSVConsultationUpsell,
    [UpsellSlugs.AcyclovirCream]: AcyclovirCreamConsultationUpsell,
    [UpsellSlugs.AhWellnessPanel]: AhWellnessPanelConsultationUpsell,
    [UpsellSlugs.Vasculera]: VasculeraConsultationUpsell,
    [UpsellSlugs.Glp1Booster]: Glp1BoosterConsultationUpsell,
    [UpsellSlugs.OvernightShipping]: OvernightShippingConsultationUpsell,
    [UpsellSlugs.SemaglutideInjectable0_5mg]: SemaglutideInjectable0_5mgConsultationUpsell,
    [UpsellSlugs.SemaglutideInjectable1mg]: SemaglutideInjectable1mgConsultationUpsell,
    [UpsellSlugs.SemaglutideInjectable1_7mg]: SemaglutideInjectable1_7mgConsultationUpsell,
    [UpsellSlugs.SemaglutideInjectable2_5mg]: SemaglutideInjectable2_5mgConsultationUpsell,
    [UpsellSlugs.SemaglutideOral5mg]: SemaglutideOral5mgConsultationUpsell,
    [UpsellSlugs.SemaglutideOral12mg]: SemaglutideOral12mgConsultationUpsell,
    [UpsellSlugs.TirzepatideInjectable5mg]: TirzepatideInjectable5mgConsultationUpsell,
    [UpsellSlugs.TirzepatideInjectable7_5mg]: TirzepatideInjectable7_5mgConsultationUpsell,
    [UpsellSlugs.TirzepatideInjectable10mg]: TirzepatideInjectable10mgConsultationUpsell,
    [UpsellSlugs.TirzepatideInjectable12_5mg]: TirzepatideInjectable12_5mgConsultationUpsell,
    [UpsellSlugs.TirzepatideInjectable15mg]: TirzepatideInjectable15mgConsultationUpsell,
    [UpsellSlugs.TirzepatideOral4mg]: TirzepatideOral4mgConsultationUpsell,
    [UpsellSlugs.TirzepatideOral5mg]: TirzepatideOral5mgConsultationUpsell,
    [UpsellSlugs.Std10TestPanel]: Std10TestPanelConsultationUpsell,
    [UpsellSlugs.MaleBVPartnerTreatment]: MaleBVPartnerTreatmentConsultationUpsell,
    [UpsellSlugs.ZofranTreatmentDissolvableTabletUpsell]: ZofranTreatmentDissolvableTabletConsultationUpsell,
    [UpsellSlugs.RectalCreamAndSuppositoryUpsell]: RectalCreamAndSuppositoryConsultationUpsell,
    [UpsellSlugs.Doxycycline1Treatment]: Doxycycline1TreatmentConsultationUpsell,
    [UpsellSlugs.Doxycycline15Treatments]: Doxycycline15TreatmentsConsultationUpsell,
    [UpsellSlugs.Doxycycline30Treatments]: Doxycycline30TreatmentsConsultationUpsell,
    [UpsellSlugs.Doxycycline30TreatmentsUpsellFrom15]: Doxycycline30TreatmentsUpsellFrom15ConsultationUpsell,
    [UpsellSlugs.FiberSupplement]: FiberSupplementConsultationUpsell,
    [UpsellSlugs.StoolSoftener]: StoolSoftenerConsultationUpsell,
    [UpsellSlugs.AzelaicAcid]: AzelaicAcidConsultationUpsell,
    [UpsellSlugs.Metformin]: MetforminStdConsultationUpsell,
    [UpsellSlugs.Spf50Sunscreen]: Spf50SunscreenConsultationUpsell,
    [UpsellSlugs.ZincSupplement]: ZincSupplementConsultationUpsell,
    [UpsellSlugs.Doxycycline]: DoxycyclineConsultationUpsell,
    [UpsellSlugs.PriorityProcessing]: PriorityProcessingConsultationUpsell,
    [UpsellSlugs.Minoxidil]: MinoxidilConsultationUpsell,
    [UpsellSlugs.OralAntiInflammatorySkinMedication]: OralAntiInflammatorySkinMedicationConsultationUpsell,
    [UpsellSlugs.AtopiclairBarrierCream]: AtopiclairBarrierCreamConsultationUpsell,
  },
} satisfies Partial<AppEnvironment>;
